import { combineReducers } from 'redux';
import characterSlice from './characterSlice';
import userSlice from './userSlice';
import chatSlice from './chatSlice';
import settingSlice from './settingSlice';

// ==============================|| COMBINE REDUCERS ||============================== //

const reducers = combineReducers({
  user: userSlice,
  chat: chatSlice,
  character: characterSlice,
  setting: settingSlice
});

export default reducers;
